import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Turkish() {
  return (
    <ApiCommunityDirectoryPage
      community="Turkish"
      eyebrow="Turkish community guide"
      title="Turkish favorites, businesses, and local essentials in San Antonio."
      
      tags={["Turkish community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Turkish community guide?"
      modalIdPrefix="turkish-directory"
    />
  );
}
